// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1DReK","fileBtn":"File_fileBtn__2CunL","closeBtn":"File_closeBtn__29P2Q","fileSelected":"File_fileSelected__36Tdg","disabled":"File_disabled__1QYyK"};